import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer11 = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) {
            setEmail('');
        }
    };

    const shopLinks = [
        { label: 'Sherwanis', path: '/template11/shop' },
        { label: 'Kurta Pajamas', path: '/template11/shop' },
        { label: 'Nehru Jackets', path: '/template11/shop' },
        { label: 'Formal Suits', path: '/template11/shop' },
        { label: 'Accessories', path: '/template11/shop' },
    ];

    const customerCareLinks = [
        { label: 'Contact Us', path: '/template11/contact' },
        { label: 'Shipping Policy', path: '/template11/shipping-exchange' },
        { label: 'Returns & Exchange', path: '/template11/shipping-exchange' },
        { label: 'FAQs', path: '/template11/faqs' },
        { label: 'Track Order', path: '/template11/orders' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Source+Sans+3:wght@300;400;600&display=swap');
            `}</style>

            <footer style={{ backgroundColor: '#1C1917', borderTop: '1px solid #44403C' }}>
                {/* Main Footer Content */}
                <div
                    style={{
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '64px 24px',
                    }}
                    className="veer-footer-main"
                >
                    <div className="veer-footer-grid">
                        {/* Column 1: Brand */}
                        <div>
                            <h3
                                style={{
                                    fontFamily: "'Oswald', sans-serif",
                                    fontSize: '32px',
                                    fontWeight: 700,
                                    color: '#D97706',
                                    letterSpacing: '6px',
                                    margin: '0 0 16px 0',
                                    textTransform: 'uppercase',
                                }}
                            >
                                VEER
                            </h3>
                            <p
                                style={{
                                    fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                    fontSize: '14px',
                                    color: '#A8A29E',
                                    lineHeight: 1.7,
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Commanding presence. Timeless craft. Indian menswear redefined for the modern man.
                            </p>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                {[Instagram, Facebook].map((Icon, i) => (
                                    <a
                                        key={i}
                                        href="#"
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            border: '1px solid #44403C',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#A8A29E',
                                            transition: 'all 0.3s ease',
                                            textDecoration: 'none',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = '#D97706';
                                            e.currentTarget.style.color = '#D97706';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = '#44403C';
                                            e.currentTarget.style.color = '#A8A29E';
                                        }}
                                    >
                                        <Icon size={18} />
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Column 2: Shop */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Oswald', sans-serif",
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    color: '#FAFAF9',
                                    margin: '0 0 20px 0',
                                }}
                            >
                                SHOP
                            </h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                {shopLinks.map((link) => (
                                    <button
                                        key={link.label}
                                        onClick={() => navigate(link.path)}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            color: '#A8A29E',
                                            cursor: 'pointer',
                                            textAlign: 'left',
                                            padding: 0,
                                            transition: 'color 0.3s ease',
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.color = '#D97706')}
                                        onMouseLeave={(e) => (e.currentTarget.style.color = '#A8A29E')}
                                    >
                                        {link.label}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Column 3: Customer Care */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Oswald', sans-serif",
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    color: '#FAFAF9',
                                    margin: '0 0 20px 0',
                                }}
                            >
                                CUSTOMER CARE
                            </h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                {customerCareLinks.map((link) => (
                                    <button
                                        key={link.label}
                                        onClick={() => navigate(link.path)}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            color: '#A8A29E',
                                            cursor: 'pointer',
                                            textAlign: 'left',
                                            padding: 0,
                                            transition: 'color 0.3s ease',
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.color = '#D97706')}
                                        onMouseLeave={(e) => (e.currentTarget.style.color = '#A8A29E')}
                                    >
                                        {link.label}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Column 4: Newsletter */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Oswald', sans-serif",
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    color: '#FAFAF9',
                                    margin: '0 0 20px 0',
                                }}
                            >
                                STAY CONNECTED
                            </h4>
                            <p
                                style={{
                                    fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                    fontSize: '14px',
                                    color: '#A8A29E',
                                    lineHeight: 1.6,
                                    margin: '0 0 16px 0',
                                }}
                            >
                                Get early access to new collections and exclusive offers.
                            </p>
                            <form onSubmit={handleSubscribe} style={{ display: 'flex', gap: '0' }}>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Your email"
                                    style={{
                                        flex: 1,
                                        padding: '12px 16px',
                                        backgroundColor: '#292524',
                                        border: '1px solid #44403C',
                                        borderRight: 'none',
                                        color: '#FAFAF9',
                                        fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                        fontSize: '14px',
                                        outline: 'none',
                                    }}
                                />
                                <button
                                    type="submit"
                                    style={{
                                        padding: '12px 20px',
                                        backgroundColor: '#D97706',
                                        border: '1px solid #D97706',
                                        color: '#1C1917',
                                        fontFamily: "'Oswald', sans-serif",
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        letterSpacing: '2px',
                                        textTransform: 'uppercase',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease',
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F59E0B')}
                                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#D97706')}
                                >
                                    JOIN
                                </button>
                            </form>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div
                    style={{
                        borderTop: '1px solid #44403C',
                        padding: '20px 24px',
                        maxWidth: '1400px',
                        margin: '0 auto',
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: '12px',
                    }}
                >
                    <p
                        style={{
                            fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                            fontSize: '13px',
                            color: '#78716C',
                            margin: 0,
                        }}
                    >
                        &copy; 2026 VEER. All rights reserved.
                    </p>
                    <div style={{ display: 'flex', gap: '24px' }}>
                        {[
                            { label: 'Privacy Policy', path: '/template11/privacy-policy' },
                            { label: 'Terms & Conditions', path: '/template11/terms-conditions' },
                        ].map((link) => (
                            <button
                                key={link.label}
                                onClick={() => navigate(link.path)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                    fontSize: '13px',
                                    color: '#78716C',
                                    cursor: 'pointer',
                                    padding: 0,
                                    transition: 'color 0.3s ease',
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.color = '#D97706')}
                                onMouseLeave={(e) => (e.currentTarget.style.color = '#78716C')}
                            >
                                {link.label}
                            </button>
                        ))}
                    </div>
                </div>
            </footer>

            <style>{`
                .veer-footer-grid {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 40px;
                }
                @media (min-width: 768px) {
                    .veer-footer-grid {
                        grid-template-columns: 1.5fr 1fr 1fr 1.5fr;
                        gap: 48px;
                    }
                }
            `}</style>
        </>
    );
};

export default Footer11;
